import { useAnchorScroll } from '#imports'

/**
 * Scrolls smoothly to element by its id
 * @param id is the css id
 */
export function useScrollToAnchor(id: string) {
  const { scrollToAnchor } = useAnchorScroll(
    {
      toAnchor: {
        scrollOptions: {
          behavior: 'smooth',
          offsetTop: 0,
        },
      },
    },
  )
  const scroll = () => {
    if (!id) return
    scrollToAnchor(`#${id}`)
  }

  return { scroll }
}
